import Vue from 'vue';

// Sentry
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';

Sentry.init({
	Vue,
	dsn: 'https://b7d783bd230144628eb5de6ed15c564e@o489467.ingest.sentry.io/5551724',
	beforeSend(event: any) {
		return event;
	},
	denyUrls: ['localhost'],
	sampleRate: 1.0,
	autoSessionTracking: true,
	integrations: [new Integrations.BrowserTracing()],
	tracesSampleRate: 0.2,
	logErrors: true,
});
